import React from 'react';

import classNames from 'classnames';
import './styles.css';

const ErrorField = ({touched, error, className}: any) => {
  return (
    <div className={classNames(className)}>
      {touched && error && <div className="ErrorField">{error}</div>}
    </div>
  );
};

export default ErrorField;
